import lampIcon from './img/lamp-icon.svg';
import imageAreaTip from './img/image-area-tip.svg';
import darkeningImageTip from './img/darkening-image-tip.png';
import { t } from 'i18next';
import { PageSidebar, PageSidebarIcon, PageSidebarList, PageSidebarText, PageSidebarTitle } from '@/components/custom/page';

export function CourseSidebarTips(props) {
  const { step } = props;

  return (
    <>
      {step === 'sobre' && <PageSidebar />}

      {step === 'imagem' && (
        <PageSidebar
          bg
          className="animate-fade-in"
        >
          <PageSidebarIcon>
            <img
              src={lampIcon}
              alt="ícone lâmpada"
            />
          </PageSidebarIcon>

          <PageSidebarTitle>{t('courses.coverImage')}</PageSidebarTitle>
          <PageSidebarText>{t('courses.asideTextDescription')}</PageSidebarText>
          <PageSidebarText className="mb-0">
            <strong>{t('courses.observations')}</strong>
          </PageSidebarText>
          <PageSidebarList>
            <li>
              <div dangerouslySetInnerHTML={{ __html: t('courses.asideTextDimensions') }}></div>
              <img
                src={imageAreaTip}
                alt={t('courses.asideImageSecurity')}
              />
            </li>
            <li>
              <div dangerouslySetInnerHTML={{ __html: t('courses.asideTextLegibility') }}></div>
              <br />
              <img
                src={darkeningImageTip}
                alt={t('courses.asideTextAltTip')}
              />
            </li>
          </PageSidebarList>
          <PageSidebarText variant="tip">
            <div dangerouslySetInnerHTML={{ __html: t('courses.AsideTextTip') }}></div>
          </PageSidebarText>
        </PageSidebar>
      )}
    </>
  );
}
